import { createConsumptionDataNode } from './utils/dataNodeUtils'
import { createExperimentRef, getContextFromInflatedId } from '../../../byRefUtils'
import { getItemsList } from '../../../templateNodes/dataNodes/Behaviors'
import { ObsoleteBehaviorsList, pointers } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'
import { INFLATED_DATA } from '../../../constants'
import { getDataItemRefsWithOverrides, resolveOverrideItem } from '../../dataConsumption'
import { DependenciesData } from './types'
import { Ref } from '@wix/materializer'

type Dependencies = {
	dataItemWithOverrides: Array<Ref<ObsoleteBehaviorsList>>
	useBehaviorsDataNode: Ref<boolean>
}

export const Behaviors = createConsumptionDataNode<DependenciesData, Dependencies, Dependencies>({
	getDependencies: (data) => ({
		dataItemWithOverrides: getDataItemRefsWithOverrides(data) as Array<Ref<ObsoleteBehaviorsList>>,
		useBehaviorsDataNode: createExperimentRef('specs.thunderbolt.useBehaviorsDataNode'),
	}),
	toViewItem: ({ id, value, rawModel }) => {
		const { dataItemWithOverrides, useBehaviorsDataNode } = value

		const dataItems = _(dataItemWithOverrides)
			.filter((dataItem) => !!dataItem)
			.value()

		if (dataItems.length === 0) {
			return
		}

		const resolvedBehaviorDataItem = resolveOverrideItem(dataItemWithOverrides, id) as ObsoleteBehaviorsList

		if (!useBehaviorsDataNode) {
			return resolvedBehaviorDataItem
		}

		let shouldUpdateData = true
		const existingData = _.get(rawModel, [INFLATED_DATA, pointers.data.DATA_MAPS.BEHAVIORS, id])
		const context = getContextFromInflatedId(id)

		const itemsList = getItemsList(resolvedBehaviorDataItem.items)
		_.forEach(itemsList, (actionBehaviorItem) => {
			const actionSourceId = _.get(actionBehaviorItem, ['action', 'sourceId'])

			if (actionSourceId && getContextFromInflatedId(actionSourceId) !== context) {
				shouldUpdateData = false
			}
		})

		// since the template comp can be consumed in different refComps, but is still dependent on the same dataItem,
		// we need to make sure we don't override the original behavior dataItem
		return shouldUpdateData ? resolvedBehaviorDataItem : existingData
	},
})
